/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/countries';
import '../common/languages';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "jedi": {
        "nested": {
          "service": {
            "nested": {
              "StartSessionRequest": {
                "fields": {
                  "employmentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "anonymousToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 4,
                    "rule": "optional"
                  },
                  "languageCode": {
                    "type": "squareup.common.languages.Language",
                    "id": 5,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "client": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "componentLibraryVersion": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "deviceType": {
                    "type": "squareup.jedi.service.DeviceType",
                    "id": 10,
                    "rule": "optional"
                  },
                  "routingGroup": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "merchantQuestion": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "deflectionData": {
                    "type": "squareup.jedi.service.DeflectionData",
                    "id": 13,
                    "rule": "optional"
                  },
                  "referer": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "DeflectionData": {
                "fields": {
                  "sessionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantQuestion": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "StartSessionResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sessionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "code": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "PanelRequest": {
                "fields": {
                  "sessionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "panelToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "inputs": {
                    "type": "squareup.jedi.service.Input",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "anonymousToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transitionId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "PanelResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "panel": {
                    "type": "squareup.jedi.service.Panel",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "code": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transitionId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "SearchRequest": {
                "fields": {
                  "sessionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "searchText": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SearchResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "panel": {
                    "type": "squareup.jedi.service.Panel",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "code": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "WaitTimeRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "WaitTimeResponse": {
                "fields": {
                  "phoneWaitMinutes": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "messagingWaitMinutes": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Panel": {
                "fields": {
                  "panelToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sessionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "components": {
                    "type": "squareup.jedi.service.Component",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "displaySearchBar": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "Component": {
                "fields": {
                  "kind": {
                    "type": "squareup.jedi.service.ComponentKind",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "parameters": {
                    "type": "string",
                    "id": 3,
                    "keyType": "string"
                  },
                  "items": {
                    "type": "squareup.jedi.service.ComponentItem",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "ComponentItem": {
                "fields": {
                  "label": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "showOther": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.jedi.service.ComponentItemType",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "Input": {
                "fields": {
                  "kind": {
                    "type": "squareup.jedi.service.InputKind",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "DeviceType": {
                "values": {
                  "PHONE": 1,
                  "TABLET": 2
                }
              },
              "ComponentItemType": {
                "values": {
                  "TEXT_ITEM": 1
                }
              },
              "InputKind": {
                "values": {
                  "BUTTON_PRESS": 1,
                  "TEXT": 2,
                  "BOOLEAN": 3
                }
              },
              "ComponentKind": {
                "values": {
                  "TEXT_FIELD": 4,
                  "HEADLINE": 5,
                  "LINK": 9,
                  "INPUT_CONFIRMATION": 10,
                  "BACK": 12,
                  "BANNER": 14,
                  "INSTANT_ANSWER": 15,
                  "PARAGRAPH": 19,
                  "PROGRESS_BAR": 21,
                  "SEARCH_BAR": 22,
                  "ROW": 24,
                  "SINGLE_SELECT_LIST": 25,
                  "MULTI_SELECT_LIST": 26,
                  "DATE_PICKER": 27,
                  "SECTION_HEADER": 28,
                  "BUTTON_BASE": 29,
                  "ICON": 30,
                  "BUTTON": 1,
                  "TILE": 2,
                  "ANSWER": 3,
                  "HERO_HEADLINE": 6,
                  "FEEDBACK": 7,
                  "CALL_TO_ACTION": 8,
                  "RESOLUTION": 11,
                  "PHONE_SUPPORT_INFO": 13,
                  "ORDER_DETAIL": 16,
                  "ORDER_TRACKING_STATUS": 17,
                  "DETAIL_ROW": 18,
                  "SEPARATOR": 20,
                  "INLINE_BANNER": 23
                }
              },
              "JediService": {
                "methods": {
                  "GetPanel": {
                    "requestType": "squareup.jedi.service.PanelRequest",
                    "responseType": "squareup.jedi.service.PanelResponse"
                  },
                  "Search": {
                    "requestType": "squareup.jedi.service.SearchRequest",
                    "responseType": "squareup.jedi.service.SearchResponse"
                  },
                  "StartSession": {
                    "requestType": "squareup.jedi.service.StartSessionRequest",
                    "responseType": "squareup.jedi.service.StartSessionResponse"
                  },
                  "GetWaitTime": {
                    "requestType": "squareup.jedi.service.WaitTimeRequest",
                    "responseType": "squareup.jedi.service.WaitTimeResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.StartSessionRequest && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.DeflectionData && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.StartSessionResponse && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.PanelRequest && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.PanelResponse && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.SearchRequest && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.SearchResponse && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.WaitTimeRequest && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.WaitTimeResponse && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.Panel && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.Component && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.ComponentItem && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.Input && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.DeviceType && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.ComponentItemType && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.InputKind && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.ComponentKind && !$root.nested?.squareup?.nested?.jedi?.nested?.service?.nested?.JediService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE StartSessionRequest @ squareup/jedi/service.proto at 10:1
 */
export const StartSessionRequest = $root.lookupType('squareup.jedi.service.StartSessionRequest');
fixType(StartSessionRequest);
Builder.createAndAttachToType(StartSessionRequest);
/**
 * SOURCE DeflectionData @ squareup/jedi/service.proto at 27:1
 */
export const DeflectionData = $root.lookupType('squareup.jedi.service.DeflectionData');
fixType(DeflectionData);
Builder.createAndAttachToType(DeflectionData);
/**
 * SOURCE StartSessionResponse @ squareup/jedi/service.proto at 32:1
 */
export const StartSessionResponse = $root.lookupType('squareup.jedi.service.StartSessionResponse');
fixType(StartSessionResponse);
Builder.createAndAttachToType(StartSessionResponse);
/**
 * SOURCE PanelRequest @ squareup/jedi/service.proto at 39:1
 */
export const PanelRequest = $root.lookupType('squareup.jedi.service.PanelRequest');
fixType(PanelRequest);
Builder.createAndAttachToType(PanelRequest);
/**
 * SOURCE PanelResponse @ squareup/jedi/service.proto at 47:1
 */
export const PanelResponse = $root.lookupType('squareup.jedi.service.PanelResponse');
fixType(PanelResponse);
Builder.createAndAttachToType(PanelResponse);
/**
 * SOURCE SearchRequest @ squareup/jedi/service.proto at 55:1
 */
export const SearchRequest = $root.lookupType('squareup.jedi.service.SearchRequest');
fixType(SearchRequest);
Builder.createAndAttachToType(SearchRequest);
/**
 * SOURCE SearchResponse @ squareup/jedi/service.proto at 60:1
 */
export const SearchResponse = $root.lookupType('squareup.jedi.service.SearchResponse');
fixType(SearchResponse);
Builder.createAndAttachToType(SearchResponse);
/**
 * SOURCE WaitTimeRequest @ squareup/jedi/service.proto at 67:1
 */
export const WaitTimeRequest = $root.lookupType('squareup.jedi.service.WaitTimeRequest');
fixType(WaitTimeRequest);
Builder.createAndAttachToType(WaitTimeRequest);
/**
 * SOURCE WaitTimeResponse @ squareup/jedi/service.proto at 73:1
 */
export const WaitTimeResponse = $root.lookupType('squareup.jedi.service.WaitTimeResponse');
fixType(WaitTimeResponse);
Builder.createAndAttachToType(WaitTimeResponse);
/**
 * SOURCE Panel @ squareup/jedi/service.proto at 78:1
 */
export const Panel = $root.lookupType('squareup.jedi.service.Panel');
fixType(Panel);
Builder.createAndAttachToType(Panel);
/**
 * SOURCE Component @ squareup/jedi/service.proto at 85:1
 */
export const Component = $root.lookupType('squareup.jedi.service.Component');
fixType(Component);
Builder.createAndAttachToType(Component);
/**
 * SOURCE ComponentItem @ squareup/jedi/service.proto at 92:1
 */
export const ComponentItem = $root.lookupType('squareup.jedi.service.ComponentItem');
fixType(ComponentItem);
Builder.createAndAttachToType(ComponentItem);
/**
 * SOURCE Input @ squareup/jedi/service.proto at 99:1
 */
export const Input = $root.lookupType('squareup.jedi.service.Input');
fixType(Input);
Builder.createAndAttachToType(Input);
/**
 * SOURCE DeviceType @ squareup/jedi/service.proto at 105:1
 */
export const DeviceType = $root.lookupEnum('squareup.jedi.service.DeviceType').values;
/**
 * SOURCE ComponentItemType @ squareup/jedi/service.proto at 110:1
 */
export const ComponentItemType = $root.lookupEnum('squareup.jedi.service.ComponentItemType').values;
/**
 * SOURCE InputKind @ squareup/jedi/service.proto at 114:1
 */
export const InputKind = $root.lookupEnum('squareup.jedi.service.InputKind').values;
/**
 * SOURCE ComponentKind @ squareup/jedi/service.proto at 120:1
 */
export const ComponentKind = $root.lookupEnum('squareup.jedi.service.ComponentKind').values;
/**
 * SOURCE JediService @ squareup/jedi/service.proto at 156:1
 */
export const JediService = $root.lookupService('squareup.jedi.service.JediService');